import React, { ElementRef } from 'react';
import ReactSelect, { components, Props } from 'react-select';

const ValueContainer = ({ children, getValue, ...props }: any) => {
  const label = props.label || 'item';
  const labelPlural = label[ label.length - 1 ] === 's' ? 'es' : 's';
  const length = getValue().length;
  let text = '';
  if (length) {
    if (length === 1) {
      if (props.isMulti) {
        text = getValue()[ 0 ].label;
      }
    } else {
      text = `${length} ${label}${length !== 1 ? labelPlural : ''} selected`;
      if (length === props.options.length) {
        text = `All ${label + labelPlural} selected`;
      }
    }

  }
  return (
    <components.ValueContainer {...props}>
      {children}
      <div className="text-container">{text}</div>
    </components.ValueContainer>
  );
};

interface CustomProps extends Props<{ value: undefined | string, label: string }> {
  disableClear?: boolean;
  handleBlurChanged?: () => void;
  equalWidthElement?: boolean;
  disableMinWidth?: boolean;
  marginTop?: boolean;
  elWidth?: number;
  zIndex?: number;
}

class Select extends React.Component<CustomProps, any> {
  selectRef: ElementRef<any>;

  readonly state: any = {
    menuIsOpen: false
  };

  componentDidMount() {
    if (
      this.props.value && (this.props.value as any[])[ 0 ] && (this.props.value as any[])[ 0 ].value
      && !(this.props.value as any[])[ 1 ] && !this.props.isMulti
      && this.props.onChange) {
      this.props.onChange((this.props.value as any[])[ 0 ], { action: 'select-option' });
    }
  }

  componentDidUpdate(prevProps: any) {
    if (this.props.value != prevProps.value && this.props.value &&
      (this.props.value as any[])[ 0 ] && (this.props.value as any[])[ 0 ].value
      && !(this.props.value as any[])[ 1 ] && !this.props.isMulti
      && this.props.onChange) {
      if (this.props.value && prevProps.value && (prevProps.value as any[])[ 0 ] && (prevProps.value as any[])[ 0 ].value
        && !(prevProps.value as any[])[ 1 ] && (this.props.value as any[])[ 0 ].value == (prevProps.value as any[])[ 0 ].value) return;
      this.props.onChange((this.props.value as any[])[ 0 ], { action: 'select-option' });
    }
    if (prevProps.value != this.state.value && !this.props.isMulti && prevProps.value[ 0 ]
      && !prevProps.value[ 1 ] && this.props.onChange) {
      this.props.onChange(prevProps.value[ 0 ], { action: 'select-option' });
    }
  }

  closeSelect = () => {
    this.setState({ menuIsOpen: false });
  };

  changeToggled = (e: any, f: any) => {
    if (this.props.onChange) {
      this.props.onChange(e, f);
    }
    const that: any = this;
    setTimeout(() => that.selectRef.focus());
  };

  clearOption = () => {
    if (this.props.onChange) {
      console.log('clearOption');
      this.props.onChange([], { action: 'clear' });
    }
    const that: any = this;
    setTimeout(() => that.selectRef.focus());
  };

  render() {
    return (
      <div className={`select-container ${!!this.props.equalWidthElement ? 'equal-width' : ''} 
      ${!!this.props.disableMinWidth ? 'disable-min-width' : ''} ${(!this.props.elWidth && !this.props.isMulti) ?
        'limited-width' : ''} ${!!this.props.marginTop ? 'space-above' : ''} 
          ${!!this.props.isMulti ? 'multi-select' : ''}`}
           style={this.props.elWidth ? {
             width: `${this.props.elWidth}px`,
             maxWidth: 'unset',
             zIndex:this.props.zIndex ? this.props.zIndex : 1000,
           } : {}}>
        <ReactSelect
          ref={(ref) => {
            this.selectRef = ref;
          }}
          {...this.props}
          menuPosition="fixed"
          style={{ zIndex:10000 }}
          menuPlacement={'auto'}
          closeMenuOnSelect={!this.props.isMulti}
          className={`react-select-container${this.props.className ? ` ${this.props.className}` : ''}`}
          classNamePrefix="react-select"
          onChange={this.changeToggled}
          onBlur={() => {
            if (this.props.handleBlurChanged) {
              this.props.handleBlurChanged();
            }
            this.closeSelect();
          }}
          components={{
            ValueContainer: (props) => <ValueContainer {...props} label={this.props.label}/>
          }}
        />
        {
          (this.props.value && !this.props.isMulti && (this.props.value as any).value && !this.props.disableClear && !this.props.isDisabled)
          && <div className="cancel-btn" onClick={this.clearOption}/>
        }
      </div>
    );
  }
}

export default Select;
